import React from "react";

const variants = {
  primary:
    "bg-brand-gradient bg-[length:200%_auto] text-white shadow-[0_8px_20px_rgba(151,1,251,0.3)] hover:bg-right hover:shadow-glow-purple hover:-translate-y-0.5",
  gold:
    "bg-gold-gradient text-[#0b0916] shadow-[0_8px_20px_rgba(239,191,4,0.3)] hover:shadow-glow-gold hover:-translate-y-0.5",
  outline:
    "bg-transparent border border-brand-gold/70 text-brand-gold hover:bg-brand-gold/10 hover:border-brand-gold",
  ghost: "bg-white/[0.05] text-white hover:bg-white/10 border border-white/10",
  danger:
    "bg-transparent border border-red-400/70 text-red-400 hover:bg-red-400/10",
};

const sizes = {
  sm: "text-sm px-4 py-1.5 rounded-full",
  md: "text-base px-6 py-2.5 rounded-full",
  lg: "text-lg px-8 py-3.5 rounded-full",
};

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  disabled,
  children,
  ...props
}) {
  return (
    <button
      disabled={disabled}
      className={[
        "font-heading font-bold tracking-wide transition-all duration-200 inline-flex items-center justify-center gap-2",
        variants[variant] || variants.primary,
        sizes[size] || sizes.md,
        disabled ? "opacity-40 cursor-not-allowed hover:translate-y-0" : "",
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </button>
  );
}
